export const defaultTimeoutToHide = 2 * 1000;
